<template>
	<div
		v-if="ready"
		class="container"
	>

		<div class="row center">
			<div class="col-lg-8 col-md-12">
				<h1 class="main-content-title">
					{{ translations.navigation.profile }}
				</h1>
			</div>
		</div>

		<div class="row center">
			<div class="col-lg-8 col-md-12">
				<div class="box">
					<div class="box-head with-line">
						<h3>
							{{ translations.labels.personalData }}
						</h3>
						<div class="box-head-text">
							{{ translations.labels.personalDataText }}
						</div>
					</div>
					<div class="box-body">
						<el-form
							@submit.prevent.native="submitForm('form')"
							:model="form"
							:rules="rules"
							ref="form"
						>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label class="required with-margin-top">
										{{ translations.labels.firstName }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="firstName">
										<el-input
											v-model="form.firstName"
											:placeholder="translations.labels.enterFirstName"
											type="text"
											clearable
										/>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label class="required with-margin-top">
										{{ translations.labels.lastName }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="lastName">
										<el-input
											v-model="form.lastName"
											:placeholder="translations.labels.enterLastName"
											type="text"
											clearable
										/>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label class="required with-margin-top">
										{{ translations.labels.email }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="email">
										<el-input
											v-model="form.email"
											:placeholder="translations.labels.enterEmail"
											type="email"
											clearable
										/>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label class="required with-margin-top">
										{{ translations.labels.prefferedLanguage }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="language">
										<el-select
											v-model="form.settings.language"
											:placeholder="translations.labels.enterPrefferedLanguage"
											style="width: 100%"
										>
											<el-option
												v-for="(language, index) in availableLanguages"
												:key="index"
												:label="language.title"
												:value="language.code"
											>
												<div class="flex-start" style="height: 34px;">
													<span>
														<img :src="`/images/flags/${language.code}.png`" class="el-select-dropdown__item-flag" />
													</span>
													<span>
														{{ language.title }}
													</span>
												</div>
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label class="with-margin-top">
										{{ translations.labels.timezone }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="timezone">
										<el-select
											v-model="form.settings.timezone"
											:placeholder="translations.labels.selectTimezone"
											style="width: 100%"
											filterable
										>
											<el-option
												v-for="(zone, index) in timezones"
												:key="index"
												:label="zone.text"
												:value="zone.text"
											/>
										</el-select>
									</el-form-item>
								</div>
							</div>
							<div class="row margin-bottom-10">
								<div class="col-lg-3 col-sm-12">
									<label class="with-margin-top">
										{{ translations.labels.receiveNewsletter }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item prop="newsletterSubscription" class="no-margin-bottom">
										<el-switch v-model="form.newsletterSubscription" />
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-12 align-right">
									<el-form-item class="no-margin-bottom">
										<el-button
											:loading="processing.update"
											native-type="submit"
											class="mobile-wide"
											type="primary"
											plain
										>
											{{ translations.labels.updateProfile }}
										</el-button>
									</el-form-item>
								</div>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</div>

		<div class="row center">
			<div class="col-lg-8 col-md-12">
				<div class="box">
					<div class="box-head">
						<h3>
							{{ translations.labels.deleteAccount }}
						</h3>
						<div class="box-head-text">
							{{ translations.labels.deleteAccountText }}
						</div>
					</div>
					<div class="box-body align-right">
						<el-button
							@click.native="openDeleteDialog()"
							type="danger"
							class="mobile-wide"
							plain
						>
							{{ translations.labels.deleteAccount }}
						</el-button>
					</div>
				</div>
			</div>
		</div>

		<!-- delete dialog -->
		<el-dialog
			:title="translations.labels.areYouSure"
			:visible.sync="dialog.delete"
			:show-close="false"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			width="450px"
		>
			<div class="margin-bottom-30">
				<el-alert
					:title="createString(translations.messages.warningDeleteAccount, [deletionDate], false, false)"
					:closable="false"
					type="error"
				/>
			</div>
			{{ translations.labels.enterPasswordToConfirm }}
			<el-input
				v-model="confirmPassword"
				:placeholder="translations.labels.password"
				type="password"
				class="margin-top-10"
				ref="password"
			/>
			<div
				slot="footer"
				class="dialog-footer"
			>
				<el-button
					@click="ajaxDeleteAccount()"
					:loading="processing.delete"
					:disabled="isDisabled"
					type="danger"
					plain
				>
					{{ translations.labels.deleteAccount }}
				</el-button>
				<el-button
					@click="closeDeleteDialog()"
					plain
				>
					{{ translations.labels.cancel }}
				</el-button>
			</div>
		</el-dialog>
		<!-- /delete dialog -->

	</div>
</template>

<script>
import timezones from '@/data/timezones.json'
import { mapState } from 'vuex'

import { _updateAccount, _deleteAccount } from '@/services/api/account'

import loadTranslations from '@/services/mixins/loadTranslations'
import convertDate from '@/services/mixins/convertDate'
import createString from '@/services/mixins/createString'
import logoutUser from '@/services/mixins/logoutUser'

export default {
	name: 'Profile',
	metaInfo () {
		return {
			title: this.translations.navigation.profile
		}
	},
	mixins: [
		loadTranslations,
		convertDate,
		createString,
		logoutUser
	],
	data () {
		return {
			confirmPassword: null,
			dialog: {
				delete: false
			},
			form: {
				firstName: null,
				lastName: null,
				email: null,
				newsletterSubscription: false,
				settings: {
					language: null,
					timezone: null,
					lastTeam: null
				}
			},
			processing: {
				update: false,
				delete: false
			},
			rules: {
				firstName: [
					{ required: true, message: this.$store.state.translations.messages.enterFirstName, trigger: 'blur' }
				],
				lastName: [
					{ required: true, message: this.$store.state.translations.messages.enterLastName, trigger: 'blur' }
				],
				email: [
					{ required: true, message: this.$store.state.translations.messages.enterEmail, trigger: 'blur' },
					{ type: 'email', message: this.$store.state.translations.messages.enterCorrectEmail, trigger: 'blur' }
				],
				'settings.language': [
					{ required: true, message: this.$store.state.translations.messages.enterLanguage, trigger: 'blur' }
				]
			},
			timezones: timezones
		}
	},
	computed: {
        ...mapState(['availableLanguages']),
		isDisabled () {
			return !this.confirmPassword
		},
		deletionDate () {
			const now = new Date();
			const futureDate = new Date(now.setDate(now.getDate() + 30))
			return this.convertDate(futureDate, 'date')
		}
	},
	created () {
		this.$store.dispatch('setLoading', true)
		this.$store.dispatch('setReady', false)
		this.form = this.clone(this.user)
		this.form.settings.lastTeam = this.user.settings.lastTeam
		this.setTimezone()
	},
	mounted () {
		this.removeLoader()
	},
	methods: {

		ajaxUpdateAccount () {
			this.processing.update = true
			_updateAccount(this.form)
				.then(response => {
					this.loadTranslations(response.settings.language)
					this.$store.dispatch('setUser', response)
					setTimeout (() => {
						this.$refs.form.clearValidate()
						this.processing.update = false
						this.displayMessage(this.translations.messages.successUpdateProfile, 'success')
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage(this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
						this.processing.update = false
					}, 200)
				})
		},
		ajaxDeleteAccount () {
			this.processing.delete = true
			_deleteAccount(this.confirmPassword)
				.then(() => {
					setTimeout (() => {
						this.processing.delete = false
						this.logoutUser(true)
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage(this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
						this.processing.delete = false
					}, 200)
				})
		},

		submitForm (form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.ajaxUpdateAccount()
				} else {
					return false
				}
			})
		},
		setTimezone () {
			if (!this.form.settings.timezoneOffset) {
				const current = Intl.DateTimeFormat().resolvedOptions().timeZone
				const temp = this.timezones.find(item => item.utc.includes(current))
				this.form.settings.timezone = temp.text
			}
		},
		openDeleteDialog () {
			this.dialog.delete = true
			this.$nextTick(() => {
				this.$refs.password.focus()
			})
		},
		closeDeleteDialog () {
			this.dialog.delete = false
			this.confirm = ''
		}

	}
}
</script>
